import { Shimmer } from '@components';

// eslint-disable-next-line
import { Container, Column, Label } from './ResourcesPicturesOverview.styles';

const ResourcesPicturesLoading = () => {
  return (
    <Container style={{ marginTop: 24 }}>
      <Label>Photos</Label>

      <Container style={{ flexDirection: 'column', marginTop: 24 }}>
        <Shimmer
          style={{
            marginRight: 16,
            height: 129,
            width: 172,
            borderRadius: 8,
          }}
          primary="#f1f1f1"
          secondary="#ececec"
        />

        <Shimmer
          style={{
            marginRight: 16,
            height: 129,
            width: 172,
            borderRadius: 8,
          }}
          primary="#f1f1f1"
          secondary="#ececec"
        />

        <Shimmer
          style={{
            marginRight: 16,
            height: 129,
            width: 172,
            borderRadius: 8,
          }}
          primary="#f1f1f1"
          secondary="#ececec"
        />
      </Container>
    </Container>
  );
};

export { ResourcesPicturesLoading };
